/* eslint-disable*/
/*
  Mock packages grant ONLY mock exams — never quizzes, questions, notes, videos
  or PDFs (subscription-dataflow.md § "Mock packages").

  Callers that pass `examPlanData` (resp_exam.examPlan[0]) are the pages that must
  not open on a mock. That argument used to short-circuit every check to false
  whenever examPlan[0] was a mock — an ARBITRARY row (no ORDER BY, so effectively
  the lowest owned plan id). Monthly plans have higher ids than the mock plans, so
  a partner owning a mock and a monthly subscription was always denied, and so was
  a CFA Unlimited holder whose examPlan[0] happened to be a mock. For those callers
  mock levels are now skipped per level, which does not depend on order. Callers
  that do not pass examPlanData keep their previous behaviour. Same approach as
  Cfa1Subscription.js (D32).
*/
var checkCfa2Subscription = function checkCfa2Subscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].partner) {
              // here  inside if check for partner user  partner package suscription
              if (exam_data[i].levels[j].isActive) {
                flag = true;
                break;
              }
            } else {
              // here inside else check for  partner user normal app package subscription
              if (exam_data[i].levels[j].isActive) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};
/*
---------------------------
   Check for Notes 
---------------------------
*/
var checkCfa2NotesSubscription = function checkCfa2NotesSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].partner) {
              /*
              -----------------------
                 for partner users
              -----------------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].noteStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              ------------------
                 for app users
              ------------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].noteStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
                // Was pkg 16 (legacy copy-paste from Cfa1) which never matches.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
------------------------
  Check for videos
-----------------------
*/
var checkCfa2VideosSubscription = function checkCfa2VideosSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].partner) {
              /*
              -----------------
                For Partner
              -----------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].videoStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              -------------
                For App
              -------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].videoStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
                // Was pkg 16 (legacy copy-paste from Cfa1) which never matches
                // any active plan, so the original code was dead.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
-----------------------
  Check for PDF's
----------------------
*/
var checkCfa2PDFSubscription = function checkCfa2PDFSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  type,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].partner) {
              /*
              -------------
                For Partner
              -------------
              */

              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive
              ) {
                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                  flag = true;
                } else if (
                  exam_data[i].levels[j].noteStatus &&
                  type === 'notes'
                ) {
                  flag = true;
                }
              } else if (
                // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              -------------
                For App
              -------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive
              ) {
                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                  flag = true;
                } else if (
                  exam_data[i].levels[j].noteStatus &&
                  type === 'notes'
                ) {
                  flag = true;
                }
              } else if (
                // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
                // Was pkg 16 (legacy copy-paste from Cfa1) which never matches
                // any active plan, so the original code was dead.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 21
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};
exports.checkCfa2NotesSubscription = checkCfa2NotesSubscription;
exports.checkCfa2VideosSubscription = checkCfa2VideosSubscription;
exports.checkCfa2PDFSubscription = checkCfa2PDFSubscription;

exports.checkCfa2Subscription = checkCfa2Subscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/Cfa2Subscription.js